<template>
    <div id="produk">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Kode Voucher' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Kode Voucher</h3>

        <v-card>
            <v-card-title>
                Daftar Kode Voucher
                <v-spacer></v-spacer
                ><v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createVoucherCode()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Voucher
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="produkList"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="false"
                :custom-pagination-total-items="produkList.length"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                :loading="isLoading"
                v-on:dblClicked="updateVoucherCode()"
                v-on:deleted="confirmDelete($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            // deleteProduk(dialogConfirm.function);
                            dialogConfirm.open = false;
                            dialogConfirm.title = null;
                            dialogConfirm.function = null;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "voucher-code",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            produkList: [],
            status: {
                PUBLISH: "PUBLISHED",
                UNPUBLISH: "UNPUBLISHED",
            },
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            headers: [
                { text: "Nama Voucher", value: "voucher_name" },
                { text: "Tanggal Berlaku", value: "effective_date" },
                { text: "Tanggal Kadaluarsa", value: "expired_date" },
                { text: "Sisa Voucher", value: "voucher_remaining" },
                { text: "Aksi", value: "actions" },
            ],
            headersKey: [
                "id",
                "name",
                "level",
                "grade",
                "type",
                "actual_price",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;

            this.isLoading = true;
            SalesService.getVoucherCode(function (result) {
                context.produkList = [];

                if (result.success) {
                    result.data.forEach(function (content, index) {
                        var row = {
                            no: index,
                            id: content.id,
                            voucher_name: content.voucher_name,
                            effective_date: content.effective_date,
                            expired_date: content.expired_date,
                            voucher_remaining: content.voucher_remaining,
                        };

                        context.produkList.push(row);
                    });
                    context.isLoading = false;
                } else {
                    alert("Terjadi kesalahan : " + result.message);
                    context.isLoading = false;
                }
            });
        },

        createVoucherCode: function () {
            this.$router.push({ path: "/kode-voucher-form" });
        },

        updateVoucherCode: function () {
            var produkId = this.selectedRow.id;
            this.$router.push({
                path: "/kode-voucher-detail",
                query: { id: produkId },
            });
        },

        updateAllProdukStatus: function (status) {
            var context = this;
            var confirmed = window.confirm(
                "Apakah anda yakin akan mengupdate semua status produk?",
            );

            if (confirmed) {
                this.isLoading = true;
                SalesService.updateAllProdukStatus(status, function (result) {
                    context.isLoading = false;

                    if (result.success) {
                        alert("Data Terupdate");
                        context.fetchData();
                    } else {
                        alert("Terjadi Kesalahan : " + result.message);
                    }
                });
            }
        },

        confirmDelete: function (produk) {
            this.dialogConfirm.title = "Hapus Kode Voucher?";
            this.dialogConfirm.function = produk;
            this.dialogConfirm.open = true;
        },

        deleteProduk: function (produk) {
            var context = this;
            var produkId = produk.id;

            SalesService.hapusPaket(produkId, function (result) {
                context.isLoading = false;
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Data Terhapus`,
                        type: "success",
                    });
                    context.fetchData();
                } else {
                    context.$store.commit("showAlert", {
                        message: `Data gagal terhapus`,
                        type: "error",
                    });
                }
                return;
            });

            this.dialogConfirm.open = false;
            this.dialogConfirm.title = null;
            this.dialogConfirm.function = null;
        },

        convertToRupiah: function (value) {
            var rupiah = "";
            var angkarev = value.toString().split("").reverse().join("");

            for (var i = 0; i < angkarev.length; i++)
                if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
            return (
                "Rp " +
                rupiah
                    .split("", rupiah.length - 1)
                    .reverse()
                    .join("")
            );
        },
    },
};
</script>



// WEBPACK FOOTER //
// VoucherCode.vue?54629826